import ServiceGraphQL from 'src/service/gql-service';
import { updateVendor } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdateVendor = (variables) => {
  const params = {
    query: updateVendor.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
